<template>
<div>
  <template v-if="$route.name === 'EXSBMessagesPeriodicUpdate'">
    <b-row>
      <b-col>
        <router-link :to="{ name: 'EXSBMessagesPeriodicList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col>
                <Form
                  :handle-submit="onSendForm"
                  :values="initialValues"
                  :violations="violations"/>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </template>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Update',
  components: {
    Form
  },
  data () {
    return {
      item: {
      }
    }
  },
  beforeDestroy () {
    this.reset()
  },
  created () {
    this.retrieve(this.id)
  },
  beforeCreate () {
    checkPagePermission('configuration', 'EXCMNotificationMessageList')
  },
  watch: {
    updated (val) {
      if (val) this.$router.push({ name: 'EXSBMessagesPeriodicList' })
    },
    retrieved (val) {
      this.item = val
    }
  },
  computed: {
    initialValues () {
      return this.item
    },
    id () {
      return this.$route.params.id
    },
    ...mapGetters({
      updated: 'exsbmessagesperiodic/update/updated',
      retrieved: 'exsbmessagesperiodic/show/retrieved',
      violations: 'exsbmessagesperiodic/update/violations'
    })
  },
  methods: {
    onSendForm () {
      this.update(this.item)
    },
    ...mapActions({
      update: 'exsbmessagesperiodic/update/update',
      retrieve: 'exsbmessagesperiodic/show/retrieve',
      reset: 'exsbmessagesperiodic/update/reset'
    })
  }
}
</script>

<style scoped>

</style>
